module.exports = __webpack_public_path__ + "static/media/naira_funds_blue.77b50e2.77b50e2d.svg";